import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";

export function DoaModal({ isOpen, currentValue, onSave, onClose }) {
  const [selected, setSelected] = useState(currentValue ?? null);

  useEffect(() => {
    if (isOpen) setSelected(currentValue ?? null);
  }, [isOpen, currentValue]);

  const handleSave = (e) => {
    e.preventDefault();
    onSave(selected);
  };

  return (
    <Modal isOpen={isOpen} contentLabel="Edit DOA Status" className="confirm-modal">
      <div className="card">
        <button onClick={onClose} className="confirm-modal-close">
          <MdClose />
        </button>
        <div className="card-header">Edit DOA Status</div>
        <form onSubmit={handleSave}>
          <div className="card-body">
            <p className="mb-2 text-muted" style={{ fontSize: "0.9rem" }}>
              Select the device arrival status for this ticket.
            </p>
            <div className="d-flex gap-2">
              <div
                onClick={() => setSelected(true)}
                style={{
                  flex: 1,
                  cursor: "pointer",
                  border: `2px solid ${selected === true ? "#dc3545" : "#dee2e6"}`,
                  borderRadius: "8px",
                  padding: "12px",
                  textAlign: "center",
                  background: selected === true ? "#fff5f5" : "#fff",
                  transition: "all 0.15s ease",
                }}
              >
                <div style={{ fontSize: "1.4rem" }}>⚠️</div>
                <div style={{ fontWeight: 600, color: selected === true ? "#dc3545" : "#212529" }}>
                  DOA
                </div>
                <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>Dead On Arrival</div>
              </div>
              <div
                onClick={() => setSelected(false)}
                style={{
                  flex: 1,
                  cursor: "pointer",
                  border: `2px solid ${selected === false ? "#198754" : "#dee2e6"}`,
                  borderRadius: "8px",
                  padding: "12px",
                  textAlign: "center",
                  background: selected === false ? "#f0fff4" : "#fff",
                  transition: "all 0.15s ease",
                }}
              >
                <div style={{ fontSize: "1.4rem" }}>✅</div>
                <div style={{ fontWeight: 600, color: selected === false ? "#198754" : "#212529" }}>
                  Non-DOA
                </div>
                <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>Working condition</div>
              </div>
            </div>
          </div>
          <div className="card-footer d-flex gap-2 justify-content-end">
            <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-outline-primary" disabled={selected === null}>
              Save
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}
